import dayjs from "dayjs"

const Filter = {
    // 时间戳转日期，格式为YYYY年MM月DD日
    TimeStamp2Date({ts,lang}) {
        return {
            'zh-CN': dayjs.unix(ts).format("YYYY年MM月DD日"),
            'zh-HK': dayjs.unix(ts).format("YYYY年MM月DD日"),
            'en-US': dayjs.unix(ts).format("MM-DD-YYYY"),
            'ja-JP': dayjs.unix(ts).format("YYYY年MM月DD日"),
        }[lang]
    },
}

export default Filter